package com.klantenstop.web.pages.profile

import com.klantenstop.web.data.models.domain.User
import com.klantenstop.web.utils.MVI

interface ProfileContract : MVI<ProfileContract.State, ProfileContract.Intent, ProfileContract.Effect> {

    data class State(
        val currentUser: User? = null,
        val firstName: String? = null,
        val lastName: String? = null,
        val email: String = "",
        val oldPassword: String = "",
        val newPassword: String = "",
        val confirmNewPassword: String = "",
        val isChangingPassword: Boolean = false,
        val resendCooldownSeconds: Int = 0,
        val verificationEmailSent: Boolean = false
    ) {
        private val firstNameChanged = currentUser?.firstName != firstName
        private val lastNameChanged = currentUser?.lastName != lastName
        private val emailChanged = currentUser?.email != email

        val hasChanged: Boolean
            get() = firstNameChanged || lastNameChanged || emailChanged

        val validNewPassword: Boolean
            get() = oldPassword.isNotBlank() && newPassword.isNotBlank() && newPassword.isPasswordStrong && newPassword == confirmNewPassword
    }

    sealed class Intent {
        data object LoadInitialData : Intent()
        data class UpdateFirstName(val firstName: String) : Intent()
        data class UpdateLastName(val lastName: String) : Intent()
        data class UpdateEmail(val email: String) : Intent()
        data object Update : Intent()
        data object ToggleChangingPassword : Intent()
        data object UpdatePassword : Intent()
        data class ChangeOldPassword(val oldPassword: String) : Intent()
        data class ChangeNewPassword(val newPassword: String) : Intent()
        data class ChangeConfirmNewPassword(val confirmNewPassword: String) : Intent()
        data object ResendVerificationEmail : Intent()
    }

    sealed class Effect {
        data class Navigate(val route: String) : Effect()
    }
}
